// Generated from workspace_layout_settings.v1.json
// DO NOT EDIT MANUALLY

import {z} from 'zod';


export const workspaceLayoutTemplateSettingsSchema = z.object({
"autoOrganizePrefix": z.union([z.literal(1), z.literal(2)]).describe("Which prefix to use for auto-organizing panels (1 = FirstPrefix, 2 = LastPrefix)").optional(),
"showEmptySections": z.boolean().describe("Whether to show sections with zero panels").optional(),
"sortAlphabetically": z.boolean().describe("Whether to sort panels alphabetically").optional()
}).strict().describe("Workspace layout settings that are saved in workspace templates")


export type WorkspaceLayoutSettingsV1 = z.infer<typeof workspaceLayoutTemplateSettingsSchema>;
